function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCapacity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 946.39 946.39",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    cx: 473.2,
    cy: 473.2,
    r: 453.65,
    style: {
      fill: "none",
      stroke: "#09d084",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "39.1px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "485.78 167.05 276.09 510.94 469 510.94 469 779.34 670.3 410.29 473.2 401.9 485.78 167.05",
    style: {
      fill: "none",
      stroke: "#09d084",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "39.1px"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCapacity);
export default __webpack_public_path__ + "static/media/capacity.475e7400fa8ce5a6448f83695dd7c262.svg";
export { ForwardRef as ReactComponent };